import CRUD from './CRUD';

/**
 * Provides a set of CRUD operations around API: /models.
 */
export default class ModelsClient extends CRUD {
	constructor() {
		super('/models');
	}
}
